import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ManageAlertsStore } from './manage-alerts.store';


const ManageAlertsContext = React.createContext<ManageAlertsStore  | null>(null);

export const ManageAlertsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<ManageAlertsStore >(() => new  ManageAlertsStore(navigate));

   return < ManageAlertsContext.Provider value={store}>{children}</ ManageAlertsContext.Provider>;
};

export const useManageAlerts = () => {
   const ctx = React.useContext(ManageAlertsContext);
   if (!ctx) {
      throw new Error('useManageAlert must be used inside ManageAlertsProvider');
   }
   return ctx;
};
